import { filter, includes, map } from "lodash";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentWorkspace } from "@radarly/core/workspace/use-cases";
import { Query } from "@radarly/models/queries";

export function useContextualFocuses(): Query[] {
  const workspace = useCurrentWorkspace();
  const project = useCurrentProject();
  if (workspace) {
    const workspaceFocuses = map(workspace?.focuses, "id");
    return filter(project.focuses, (query) =>
      includes(workspaceFocuses, query.id)
    );
  }
  return project.focuses;
}
